import { idForPath, restDelete, restGet, restPatch, restPost } from "./restClient.js";

const ROOT = "/v1/copilot-integrations";

function normalizeDeliveryMode(raw) {
    if (!raw || typeof raw !== "string") return raw;
    const m = raw.match(/^DIRECTORY_COPILOT_DELIVERY_MODE_(.+)$/);
    if (m) return m[1].toLowerCase();
    return raw;
}

function normalizeIntegration(integration) {
    if (integration) integration.deliveryMode = normalizeDeliveryMode(integration.deliveryMode);
    return integration;
}

export async function listCopilotIntegrations({ signal } = {}) {
    const result = await restGet(ROOT, null, { signal });
    for (const integration of result?.integrations ?? []) normalizeIntegration(integration);
    return result ?? { integrations: [] };
}

export async function createCopilotIntegration({
    managed = false,
    entraTenantId,
    clientId,
    clientSecret,
    copyFromDirectoryIntegrationId,
}) {
    const body = copyFromDirectoryIntegrationId
        ? { copy_from_directory_integration_id: copyFromDirectoryIntegrationId }
        : managed
          ? { managed: true }
          : {
                managed: false,
                entra_tenant_id: entraTenantId,
                client_id: clientId,
                client_secret: clientSecret,
            };
    const result = await restPost(ROOT, body);
    normalizeIntegration(result?.integration);
    return result;
}

export async function updateCopilotIntegration(integrationId, { clientId = "", clientSecret }) {
    const result = await restPatch(`${ROOT}/${idForPath(integrationId)}`, {
        client_id: clientId,
        client_secret: clientSecret,
    });
    normalizeIntegration(result?.integration);
    return result;
}

export function deleteCopilotIntegration(integrationId) {
    return restDelete(`${ROOT}/${idForPath(integrationId)}`);
}

export function getCopilotAuthUrl({ integrationId, redirectUri }) {
    return restPost(`${ROOT}:auth-url`, {
        integration_id: integrationId,
        redirect_uri: redirectUri,
    });
}

export async function completeCopilotAdminConsent({ integrationId, state, adminConsent, tenant }) {
    const result = await restPost(`${ROOT}:complete-consent`, {
        integration_id: integrationId,
        admin_consent: adminConsent,
        tenant_id: tenant,
        state,
    });
    normalizeIntegration(result?.integration);
    return result;
}
